import { render, staticRenderFns } from "./Nebalans.vue?vue&type=template&id=d13e36f8&scoped=true&"
import script from "./Nebalans.vue?vue&type=script&lang=ts&"
export * from "./Nebalans.vue?vue&type=script&lang=ts&"
import style0 from "./Nebalans.vue?vue&type=style&index=0&id=d13e36f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13e36f8",
  null
  
)

export default component.exports